module.exports = __webpack_public_path__ + "img/bucuresti-central.21572bdd.jpg";